module.exports = __webpack_public_path__ + "static/media/icon-mentoring-new.5294afde.svg";